<head>
  <title>Qtac Client Onboarding</title>
</head>
<template>
  <div id="app">
    <component :is="layout">
      <router-view />
    </component>
  </div>
</template>

<script>
import DefaultLayout from "@/layouts/Default.vue" 

export default {
  components: {
    'default-layout': DefaultLayout // must match string from `layout()` below
  },
  computed: {
    layout() {
      return (this.$route.meta.layout || 'default') + '-layout'
    }
  }
}
</script>
